/**
 * visualUtils.js — bucketing / tone / age-band helpers for the dashboard (pure).
 */
import { STALE_MINUTES, DURATION_BUCKETS } from '../ticketConstants';

export function buildBucketRows(rows, getValue, buckets = DURATION_BUCKETS) {
  const values = rows.map(getValue).filter(v => Number.isFinite(v) && v >= 0);
  const total = values.length;
  const counts = buckets.map(b => values.filter(v => v >= b.min && v < b.max).length);
  const maxCount = Math.max(...counts, 1);
  return buckets.map((b, i) => ({
    ...b,
    count: counts[i],
    pct: total > 0 ? Math.round((counts[i] / total) * 100) : 0,
    maxCount,
  }));
}

export function getTimeToneClass(mins, fastCutoff = 15, slowCutoff = 30) {
  if (mins == null) return '';
  if (mins < fastCutoff) return ' td__time--fast';
  if (mins >= slowCutoff) return ' td__time--slow';
  return '';
}

export function getAgeBand(mins) {
  if (mins < 5) return 'fresh';
  if (mins < 15) return 'warning';
  if (mins < 20) return 'medium';
  if (mins < 30) return 'urgent';
  if (mins < STALE_MINUTES) return 'critical';
  return 'stale';
}
